import { useContext } from "react";
import { ConfigContext } from "./context";

export const useConfigContext = () => useContext(ConfigContext);
